module.exports = __webpack_public_path__ + "img/battery_on_1_input.57d38c7e.png";